import React from 'react';
import $ from 'jquery';
import TaskService from '../../Services/taskService';
import JobTitleService from '../../Services/jobTitleService.js';
import ErrorMessage from '../../Elements/ErrorMessage';
import FaIcon from '../../Elements/FaIcon.js';
import UserGuideTitle from '../../Elements/UserGuideTitle';

const exportMessage =
  'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

export default class manageTasks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taskList: [],
      selectedTask: null,
      jobTitleList: [],
      selectedJobTitleList: [],
      availableJobTitleList: [],
      taskQuery: '',
      nameError: '',
      selectedJobTitlesError: '',
      onlyLeadMandatoryError: '',
    };

    this.handleSelectedTaskChange = this.handleSelectedTaskChange.bind(this);
    this.handleTaskQueryChange = this.handleTaskQueryChange.bind(this);
    this.handleAddNewTaskClick = this.handleAddNewTaskClick.bind(this);
    this.handleSaveTaskClick = this.handleSaveTaskClick.bind(this);
    this.handleDeleteTaskClick = this.handleDeleteTaskClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleTaskNameChange = this.handleTaskNameChange.bind(this);
    this.handleAddSelectedJobTitleClick = this.handleAddSelectedJobTitleClick.bind(this);
    this.handleRemoveSelectedJobTitleClick = this.handleRemoveSelectedJobTitleClick.bind(this);
    this.handleRemoveAllSelectedJobTitleClick = this.handleRemoveAllSelectedJobTitleClick.bind(this);
    this.handleIsLeadMandatoryChanged = this.handleIsLeadMandatoryChanged.bind(this);
    this.handleIsClientMandatoryChanged = this.handleIsClientMandatoryChanged.bind(this);
    this.handleIsOpportunityMandatoryChanged = this.handleIsOpportunityMandatoryChanged.bind(this);
    this.handleIsProjectMandatoryChanged = this.handleIsProjectMandatoryChanged.bind(this);
    this.handleIsTpProjectMandatoryChanged = this.handleIsTpProjectMandatoryChanged.bind(this);
    this.handleIsCommentMandatoryChanged = this.handleIsCommentMandatoryChanged.bind(this);
    this.handleExportTaskVsJobTitleClick = this.handleExportTaskVsJobTitleClick.bind(this);
  }

  render() {
    const task = this.state.selectedTask;
    const isNew = !!task && task.taskId === -1;
    const q = this.state.taskQuery.trim().toLowerCase();
    const filteredTasks = q ? this.state.taskList.filter((t) => t.name.toLowerCase().includes(q)) : this.state.taskList;
    const titleCount = this.state.selectedJobTitleList.length;
    const mandCount = task
      ? [
          task.isLeadMandatory,
          task.isClientMandatory,
          task.isOpportunityMandatory,
          task.isProjectMandatory,
          task.isTpProjectMandatory,
          task.isCommentMandatory,
        ].filter(Boolean).length
      : 0;

    const mandFields = [
      { key: 'isLeadMandatory', id: 'ckIsLeadMandatory', label: 'Lead', handler: this.handleIsLeadMandatoryChanged },
      {
        key: 'isClientMandatory',
        id: 'ckIsClientMandatory',
        label: 'Client',
        handler: this.handleIsClientMandatoryChanged,
      },
      {
        key: 'isOpportunityMandatory',
        id: 'ckIsOpportunityMandatory',
        label: 'Opportunity',
        handler: this.handleIsOpportunityMandatoryChanged,
      },
      {
        key: 'isProjectMandatory',
        id: 'ckIsProjectMandatory',
        label: 'Project',
        handler: this.handleIsProjectMandatoryChanged,
      },
      {
        key: 'isTpProjectMandatory',
        id: 'ckIsTpProjectMandatory',
        label: 'Third-Party Project',
        handler: this.handleIsTpProjectMandatoryChanged,
      },
      {
        key: 'isCommentMandatory',
        id: 'ckIsCommentMandatory',
        label: 'Comment',
        handler: this.handleIsCommentMandatoryChanged,
      },
    ];

    return (
      <div className='contentwrapper bravo-ds mt-page'>
        {/* header */}
        <div className='page-head'>
          <div className='page-title'>
            <span className='eq-mark'>
              <span></span>
              <span></span>
            </span>
            <div className='page-title-text'>
              <div className='eyebrow'>Activity</div>
              <h1>
                <UserGuideTitle title='Manage tasks'>Manage Tasks</UserGuideTitle>
              </h1>
            </div>
          </div>
          <div className='mt-actions'>
            <div className='count-pill mt-count'>
              <b>{this.state.taskList.length}</b>
              <span>tasks</span>
            </div>
            <div className='divider'></div>
            <button
              className='btn navy'
              onClick={this.handleExportTaskVsJobTitleClick}
            >
              <FaIcon iconName='fa-solid fa-file-excel' /> Job title report
            </button>
            <button
              className='btn primary'
              onClick={this.handleAddNewTaskClick}
            >
              <FaIcon iconName='fa-regular fa-square-plus' /> New task
            </button>
          </div>
        </div>

        {/* two-pane */}
        <div className='mt-stage'>
          {/* master — task list */}
          <aside className='mt-panel left'>
            <div className='mt-phead'>
              <span className='h'>Select task</span>
              <span className='sp'></span>
              <span className='cnt'>{filteredTasks.length}</span>
            </div>
            <div className='mt-search'>
              <FaIcon iconName='fa-solid fa-magnifying-glass' />
              <input
                placeholder='Search tasks…'
                value={this.state.taskQuery}
                onChange={this.handleTaskQueryChange}
              />
            </div>
            <div className='mt-tasklist'>
              {filteredTasks.map((t) => (
                <button
                  key={t.taskId}
                  className={'mt-taskrow' + (task && t.taskId === task.taskId ? ' on' : '')}
                  onClick={() => this.handleSelectedTaskChange(t.taskId)}
                  title={t.name}
                >
                  <span className='dot'></span>
                  <span className='nm'>{t.name}</span>
                  <span className='jt'>{(t.taskOfficialJobTitles && t.taskOfficialJobTitles.length) || ''}</span>
                </button>
              ))}
              {filteredTasks.length === 0 && (
                <div className='mt-emptylist'>No tasks match “{this.state.taskQuery}”.</div>
              )}
            </div>
            <div className='mt-listfoot'>
              <button
                className='btn navy'
                onClick={this.handleAddNewTaskClick}
              >
                <FaIcon iconName='fa-solid fa-plus' /> Add task
              </button>
            </div>
          </aside>

          {/* detail — properties */}
          <section className='mt-panel'>
            {task === null ? (
              <div className='mt-noselect'>
                <div className='in'>
                  <div className='ic'>
                    <FaIcon iconName='fa-solid fa-list-check' />
                  </div>
                  <b>No task selected</b>
                  <p>
                    Pick a task from the list to edit its name, eligible job titles and mandatory fields — or create a
                    new one.
                  </p>
                  <button
                    className='btn navy'
                    onClick={this.handleAddNewTaskClick}
                  >
                    <FaIcon iconName='fa-solid fa-plus' /> Add task
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className='mt-props'>
                  <div className='mt-detail-head'>
                    <span className='eyebrow'>{isNew ? 'New task' : 'Task properties'}</span>
                  </div>

                  {/* name */}
                  <div className='mt-section'>
                    <label
                      className='mt-lbl'
                      htmlFor='tbTaskName'
                    >
                      Task name <span className='req'>*</span>
                    </label>
                    <input
                      id='tbTaskName'
                      className='mt-input name'
                      value={task.name}
                      onChange={this.handleTaskNameChange}
                      maxLength='40'
                      placeholder='Task name'
                    />
                    {this.state.nameError ? <div className='mt-err'>{this.state.nameError}</div> : null}
                  </div>

                  {/* job titles shuttle */}
                  <div className='mt-section'>
                    <label className='mt-lbl'>Job titles — who can book this task</label>
                    <div className='mt-shuttle'>
                      {/* available */}
                      <div className='mt-listbox'>
                        <div className='mt-lbhead'>
                          <span className='t'>Available</span>
                          <span className='n'>{this.state.availableJobTitleList.length}</span>
                        </div>
                        <select
                          multiple
                          size='10'
                          id='selectAvailableJobTitle'
                          className='mt-jtselect'
                        >
                          {this.state.availableJobTitleList.map((t) => (
                            <option
                              key={t.value}
                              value={t.value}
                              onDoubleClick={this.handleAddSelectedJobTitleClick}
                            >
                              {t.text}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* transfer */}
                      <div className='mt-xfer'>
                        <button
                          className='mt-xbtn'
                          title='Add selected job title to task'
                          onClick={this.handleAddSelectedJobTitleClick}
                        >
                          <FaIcon iconName='fa-solid fa-angle-right' />
                        </button>
                        <button
                          className='mt-xbtn'
                          title='Remove selected job title from task'
                          onClick={this.handleRemoveSelectedJobTitleClick}
                        >
                          <FaIcon iconName='fa-solid fa-angle-left' />
                        </button>
                        <button
                          className='mt-xbtn'
                          title='Remove all job titles from task'
                          onClick={this.handleRemoveAllSelectedJobTitleClick}
                        >
                          <FaIcon iconName='fa-solid fa-angles-left' />
                        </button>
                      </div>

                      {/* selected */}
                      <div className='mt-listbox'>
                        <div className='mt-lbhead'>
                          <span className='t'>Selected for this task</span>
                          <span className='n'>{this.state.selectedJobTitleList.length}</span>
                        </div>
                        <select
                          multiple
                          size='10'
                          id='selectTaskJobTitle'
                          className='mt-jtselect'
                        >
                          {this.state.selectedJobTitleList.map((s) => (
                            <option
                              key={s.officialJobTitleValue}
                              value={s.officialJobTitleValue}
                              onDoubleClick={this.handleRemoveSelectedJobTitleClick}
                            >
                              {s.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {this.state.selectedJobTitlesError ? (
                      <div className='mt-err'>{this.state.selectedJobTitlesError}</div>
                    ) : null}
                  </div>

                  {/* mandatory fields */}
                  <div className='mt-section'>
                    <label className='mt-lbl'>Mandatory fields — required when logging this task</label>
                    <div className='mt-mand'>
                      {mandFields.map((f) => {
                        const on = !!task[f.key];
                        return (
                          <div
                            key={f.key}
                            className={'mt-mrow' + (on ? ' on' : '')}
                          >
                            <div className='txt'>
                              <b>{f.label}</b>
                              <small>{on ? 'Required' : 'Optional'}</small>
                            </div>
                            <label className='switch'>
                              <input
                                id={f.id}
                                type='checkbox'
                                checked={on}
                                onChange={() => f.handler()}
                              />
                              <span className='track'></span>
                              <span className='thumb'></span>
                            </label>
                          </div>
                        );
                      })}
                    </div>
                    {this.state.onlyLeadMandatoryError ? (
                      <div className='mt-err'>{this.state.onlyLeadMandatoryError}</div>
                    ) : null}
                  </div>
                </div>

                {/* footer */}
                <div className='mt-foot'>
                  {isNew ? (
                    <button
                      className='btn danger-ghost'
                      onClick={this.handleCancelClick}
                    >
                      <FaIcon iconName='fa-solid fa-ban' /> Cancel
                    </button>
                  ) : (
                    <button
                      className='btn danger-ghost'
                      onClick={this.handleDeleteTaskClick}
                    >
                      <FaIcon iconName='fa-solid fa-trash-can' /> Delete task
                    </button>
                  )}
                  <span className='sp'></span>
                  <span className='saved-hint'>{`${titleCount} title${
                    titleCount === 1 ? '' : 's'
                  } · ${mandCount} mandatory`}</span>
                  <button
                    className='btn primary'
                    disabled={!task.name || !task.name.trim()}
                    onClick={this.handleSaveTaskClick}
                  >
                    <FaIcon iconName='fa-solid fa-circle-check' /> Save task
                  </button>
                </div>
              </>
            )}
          </section>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.loadTaskList();
    this.loadJobTitleList();
  }

  handleTaskQueryChange(e) {
    this.setState({ taskQuery: e.target.value });
  }

  handleSelectedTaskChange(taskId) {
    const newSelectedTask = JSON.parse(JSON.stringify(this.state.taskList.find((t) => t.taskId === taskId)));

    this.setState(
      {
        selectedTask: newSelectedTask,
        nameError: '',
        selectedJobTitlesError: '',
        onlyLeadMandatoryError: '',
      },
      () => this.loadJobTitlesForTask()
    );
  }

  loadJobTitlesForTask() {
    this.setState({
      selectedJobTitleList: this.state.selectedTask.taskOfficialJobTitles
        .map((t) => ({
          taskId: t.taskId,
          officialJobTitleValue: t.officialJobTitleValue,
          name: this.state.jobTitleList.find((j) => j.value === t.officialJobTitleValue.toString()).text,
        }))
        .sort((a, b) => {
          const textA = a.name.toUpperCase();
          const textB = b.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        }),
      availableJobTitleList: this.state.jobTitleList
        .filter(
          (j) =>
            !this.state.selectedTask.taskOfficialJobTitles.some((t) => t.officialJobTitleValue.toString() === j.value)
        )
        .sort((a, b) => {
          const textA = a.text.toUpperCase();
          const textB = b.text.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        }),
    });
  }

  loadTaskList(selectTaskId) {
    TaskService.GetTaskList()
      .then((result) => {
        this.setState({ taskList: result }, () => {
          // Re-select inside the setState callback so handleSelectedTaskChange reads the
          // freshly-fetched list (a just-created task's new id is not in the old list).
          if (selectTaskId !== null && selectTaskId !== undefined) {
            this.handleSelectedTaskChange(selectTaskId);
          }
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('MT321'));
  }

  loadJobTitleList() {
    JobTitleService.GetJobTitleList()
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          return;
        }
        this.setState({ jobTitleList: result });
      })
      .catch(() => ErrorMessage.SetErrorMessage('MT331'));
  }

  handleAddNewTaskClick() {
    this.setState({
      selectedTask: {
        name: '',
        taskId: -1,
        taskOfficialJobTitles: [],
        isActive: 1,
        isLeadMandatory: 0,
        isClientMandatory: 0,
        isOpportunityMandatory: 0,
        isProjectMandatory: 0,
        isTpProjectMandatory: 0,
        isCommentMandatory: 0,
      },
      selectedJobTitleList: [],
      availableJobTitleList: this.state.jobTitleList.slice().sort((a, b) => {
        const textA = a.text.toUpperCase();
        const textB = b.text.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      }),
      nameError: '',
      selectedJobTitlesError: '',
      onlyLeadMandatoryError: '',
    });
  }

  handleSaveTaskClick() {
    if (
      !this.validateAlreadyExistingName() &&
      !this.validateAssignedJobTitle() &&
      !this.validateOnlyLeadMandatorySelected() &&
      !this.validateMissingName()
    ) {
      TaskService.SaveTask(this.state.selectedTask)
        .then((result) => {
          if (this.state.selectedTask.taskId === -1) {
            const modifiedSelectedTask = this.state.selectedTask;
            modifiedSelectedTask.taskId = result.taskId;

            this.setState({ selectedTask: modifiedSelectedTask });
            ErrorMessage.SetNotification('Task created.');
            this.loadTaskList(result.taskId);
            return;
          }
          ErrorMessage.SetNotification('Task saved.');
          this.loadTaskList(result.taskId);
        })
        .catch(() => ErrorMessage.SetErrorMessage('MT379'));
    } else {
      ErrorMessage.SetNotification('Please correct the highlighted errors.');
    }
  }

  handleDeleteTaskClick() {
    ErrorMessage.SetApprove(
      `Are sure you want to delete the task '${this.state.selectedTask.name}'?`,
      this.deleteTask.bind(this)
    );
  }

  handleCancelClick() {
    this.setState({ selectedTask: null, nameError: '', selectedJobTitlesError: '', onlyLeadMandatoryError: '' });
  }

  handleExportTaskVsJobTitleClick() {
    TaskService.ExportTaskVsJobTitleReport().catch(() => ErrorMessage.SetErrorMessage('MT434'));
    ErrorMessage.SetSuccessWithWait(exportMessage);
  }

  deleteTask() {
    TaskService.DeleteTask(this.state.selectedTask)
      .then(() => {
        this.setState({ selectedTask: null });
        this.loadTaskList();
        ErrorMessage.SetNotification('Task deleted.');
      })
      .catch(() => ErrorMessage.SetErrorMessage('MT404'));
  }

  handleTaskNameChange(e) {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.name = e.target.value;

    this.setState({ selectedTask: modifiedSelectedTask }, () => {
      this.validateMissingName();
      this.validateAlreadyExistingName();
    });
  }

  handleAddSelectedJobTitleClick() {
    if (!($('#selectAvailableJobTitle')[0].selectedOptions.length > 0)) {
      return;
    }
    const modifiedSelectedTask = this.state.selectedTask;

    for (let i = 0; i < $('#selectAvailableJobTitle')[0].selectedOptions.length; i++) {
      const jobTitleValue = parseInt($('#selectAvailableJobTitle')[0].selectedOptions[i].value);
      modifiedSelectedTask.taskOfficialJobTitles.push({
        officialJobTitleValue: jobTitleValue,
        taskId: this.state.selectedTask.taskId,
      });
    }

    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateAssignedJobTitle());

    this.loadJobTitlesForTask();
  }

  findModifiedSelectedTask(taskOfficialJobTitles, jobTitleId) {
    return taskOfficialJobTitles.filter((t) => t.officialJobTitleValue !== jobTitleId);
  }

  handleRemoveSelectedJobTitleClick() {
    if (!($('#selectTaskJobTitle')[0].selectedOptions.length > 0)) {
      return;
    }
    const modifiedSelectedTask = this.state.selectedTask;
    for (let i = 0; i < $('#selectTaskJobTitle')[0].selectedOptions.length; i++) {
      const jobTitleId = parseInt($('#selectTaskJobTitle')[0].selectedOptions[i].value);
      modifiedSelectedTask.taskOfficialJobTitles = this.findModifiedSelectedTask(
        modifiedSelectedTask.taskOfficialJobTitles,
        jobTitleId
      );
    }

    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateAssignedJobTitle());

    this.loadJobTitlesForTask();
  }

  handleRemoveAllSelectedJobTitleClick() {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.taskOfficialJobTitles = [];

    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateAssignedJobTitle());

    this.loadJobTitlesForTask();
  }

  handleIsLeadMandatoryChanged() {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.isLeadMandatory = $('#ckIsLeadMandatory')[0].checked;
    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateOnlyLeadMandatorySelected());
  }

  handleIsClientMandatoryChanged() {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.isClientMandatory = $('#ckIsClientMandatory')[0].checked;
    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateOnlyLeadMandatorySelected());
  }

  handleIsProjectMandatoryChanged() {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.isProjectMandatory = $('#ckIsProjectMandatory')[0].checked;
    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateOnlyLeadMandatorySelected());
  }

  handleIsTpProjectMandatoryChanged() {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.isTpProjectMandatory = $('#ckIsTpProjectMandatory')[0].checked;
    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateOnlyLeadMandatorySelected());
  }

  handleIsOpportunityMandatoryChanged() {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.isOpportunityMandatory = $('#ckIsOpportunityMandatory')[0].checked;
    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateOnlyLeadMandatorySelected());
  }

  handleIsCommentMandatoryChanged() {
    const modifiedSelectedTask = this.state.selectedTask;
    modifiedSelectedTask.isCommentMandatory = $('#ckIsCommentMandatory')[0].checked;
    this.setState({ selectedTask: modifiedSelectedTask }, () => this.validateOnlyLeadMandatorySelected());
  }

  validateMissingName() {
    let error = '';
    if (!this.state.selectedTask || this.state.selectedTask.name === '') {
      error = 'Task name is mandatory';
    }
    this.setState({ nameError: error });
    return error;
  }

  validateAlreadyExistingName() {
    let error = '';
    if (
      this.state.taskList.filter(
        (e) => e.name === this.state.selectedTask.name && e.taskId !== this.state.selectedTask.taskId
      ).length > 0
    ) {
      error = 'Task name must be unique';
    }
    this.setState({ nameError: error });
    return error;
  }

  validateAssignedJobTitle() {
    let error = '';
    if (this.state.selectedJobTitleList.length === 0) {
      error = 'At least one job title must be assigned to the task';
    }
    this.setState({ selectedJobTitlesError: error });
    return error;
  }

  validateOnlyLeadMandatorySelected() {
    let error = '';
    if (
      this.state.selectedTask.isLeadMandatory &&
      (this.state.selectedTask.isClientMandatory ||
        this.state.selectedTask.isOpportunityMandatory ||
        this.state.selectedTask.isProjectMandatory ||
        this.state.selectedTask.isTpProjectMandatory)
    ) {
      error =
        'Mandatory lead selection is not allowed if client / opportunity / project / third-party project is mandatory.';
    }
    this.setState({ onlyLeadMandatoryError: error });
    return error;
  }
}
